import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext, UserContext } from 'commons-ui';

import { getFormDefaults } from '../../utils/bulkFormConfig';
import useService from '../../utils/useService';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const data = getFormDefaults();
	const history = useHistory();
	const { requestCreatePartnerCoupon } = useService();

	const createCoupon = (createdData: any, rowData: any) => {
		setShowLoader(true);
		const { isDisabled, maxRedemptions, maxRedemptionsPerPerson, validFrom, validTill, partnerName, quantity, cid } = createdData;
		const newData = {
			partnerName,
			quantity,
			cid,
			uid: _get(user, 'email', ''),
			partnerCouponConfig: {
				isDisabled,
				maxRedemptions,
				maxRedemptionsPerPerson,
				validFrom,
				validTill
			}
		};

		requestCreatePartnerCoupon(app.appName, newData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(`Error: ${res?.data?.error || 'Error occured while creating the bulk of a partner coupon'}`, {
						type: 'error'
					});
					setShowLoader(false);
					return;
				}
				showAlert('Record created');
				history.push({
					pathname: '/dashboard/partnerCoupon/bulk/show',
					state: {
						rowData
					}
				});
				setShowLoader(false);
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (rowData: any) => (submittedData: any) => {
		createCoupon(submittedData, rowData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
